import React from "react";
import { Link } from "react-router-dom";
import style from "./BucketProduct.module.scss";
import LinkIcon from "../../../../assets/images/bucket/linkIcon.png";
import QuantityIcon from "../../../../assets/images/bucket/quantityIcon.png";
import DeleteIcon from "../../../../assets/images/bucket/deleteIcon.png";
import { BucketProductProps } from "../../../../interface/site.interface";

const BucketProduct: React.FC<BucketProductProps> = ({
  productLink,
  productLinkTitle,
  productCountTitle,
  productCount,
  resultPrice,
  onDelete,
}) => {
  return (
    <div className={style.bucketProduct}>
      <span></span>
      <div className={style.leftPart}>
        <div className={style.topPart}>
          <div className={style.left}>
            <img src={LinkIcon} alt="Link Icon" />
          </div>
          <div className={style.right}>
            <p className={style.productLinkTitle}>{productLinkTitle}</p>
            <Link
              to={productLink}
              target="_blank"
              className={style.productLink}
            >
              {productLink}
            </Link>
          </div>
        </div>
        <div className={style.bottomPart}>
          <div className={style.left}>
            <img src={QuantityIcon} alt="Quantity Icon" />
          </div>
          <div className={style.right}>
            <p className={style.productCountTitle}>{productCountTitle}</p>
            <p className={style.productCount}>{productCount} ədəd</p>
          </div>
        </div>
      </div>
      <div className={style.rightPart}>
        <img src={DeleteIcon} alt="Delete Icon" onClick={onDelete} />
        <p className={style.resultPrice}>{resultPrice}</p>
      </div>
    </div>
  );
};

export default BucketProduct;
